export default function getSubscriptionIntervalWithSlash(interval = '', intervalCount, labels) {
  const separator = '/';

  let intervalText = interval;

  if (labels) {
    switch (interval) {
      case 'day':
        if (labels.dayText) {
          intervalText = labels.dayText;
        }
        break;
      case 'week':
        if (labels.weekText) {
          intervalText = labels.weekText;
        }
        break;
      case 'month':
        if (labels.monthText) {
          intervalText = labels.monthText;
        }
        break;
      case 'year':
        if (labels.yearText) {
          intervalText = labels.yearText;
        }
        break;
      default:
        break;
    }
  }

  // add 's' to pluralize if intervalText hasn't been edited
  if (intervalText === interval && intervalCount && intervalCount > 1) {
    intervalText = `${intervalText}s`;
  }

  // combine interval text with intervalCountText (or 'Every')
  if (intervalCount && intervalCount > 1) {
    intervalText = [
      separator,
      (labels && labels.intervalCountText) || 'every',
      intervalCount,
      intervalText,
    ].join(' ');
  }

  if (intervalCount === 1) {
    intervalText = [separator, intervalText].join(' ');
  }

  return intervalText;
}
